import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sign-in-arrow.svg")